import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import {
    IAccountDetail,
    IAccountFields,
    IAccountSearch,
} from "../../../../AccountTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { accountService } from "../../../../AccountService";
import { transPgToPagination } from "../../../../../base/app/appModel";
import { useDetailModel } from "../detailModel";
import { UserTypeEnum } from "@/types/FmsEnums";
type OptionDsType = {
    label: string,
    value: string,
}
export const useAccountModel = createModel(function () {
    const initSearchParam: IAccountFields = {};
    const initDataSource: IAccountDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [supplierUserDs, setSupplierUserDs] = useState<OptionDsType[]>(); // 选中供应商下的账户列表
    const [supplierUserList, setSupplierUserList] = useState<IAccountDetail[]>(); // 选中供应商下的账户列表

    const [openDrawerVisible, setOpenDrawerVisible] = useState(false);
    const [adjustDrawerVisible, setAdjustDrawerVisible] = useState(false);
    const [rechargeDrawerVisible, setRechargeDrawerVisible] = useState(false);
    const [transferDrawerVisible, setTransferDrawerVisible] = useState(false);
    const [writeoffDrawerVisible, setWriteoffDrawerVisible] = useState(false);

    const { supplierCode } = useDetailModel();
    const [state, setstate] = useState(false)

    //账户类型参数account
    const [accountTypeDs, setAccountType] = useState<OptionDsType[]>([]);
    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setstate(!state)
    }



    // 根据条件返回用户options
    const getAccoutSupplierUser = async (data: IAccountFields) => {
        let result = await accountService.find({
            partnerCode: supplierCode,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            ...data
        })
        return result.retData.map(item => {
            return {
                label: item.name ?? '',
                value: item.code ?? ''
            }
        })
    }

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg) => {
        const searchParams: IAccountFields = {
            ...searchParam,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            partnerCode: supplierCode,
            // page: {
            //     pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            //     pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            // }
        }
        let { retData } = await accountService.find(searchParams);
        // const {records, ...pg} = retData;
        // setPgCfg(transPgToPagination(pg));
        // setDataSource(records);
        setDataSource(retData);
        clearSelectData();
    }


    return {
        /***field***/
        state,
        supplierCode,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        openDrawerVisible,
        adjustDrawerVisible,
        rechargeDrawerVisible,
        transferDrawerVisible,
        writeoffDrawerVisible,
        supplierUserDs,
        supplierUserList,
        accountTypeDs,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setOpenDrawerVisible,
        setAdjustDrawerVisible,
        setRechargeDrawerVisible,
        setTransferDrawerVisible,
        setWriteoffDrawerVisible,
        getAccoutSupplierUser,
        onSearch,
        onReset,
        setSelectedData,
        setSupplierUserList,
        setSupplierUserDs,
        setAccountType
    }
});
